document.addEventListener("latte:init", init);

function init() {
	$('.quiz-slider').slick({
		dots: false,
		speed: 2,
		fade: true,
		slidesToScroll: 1,
		cssEase: 'ease-in-out',
		centerPadding: '0',
		infinite: false,
		lazyLoad: 'ondemand',
		prevArrow: '<button class="slick-prev" alt="Previous Slide"></button>',
		nextArrow: '<button class="slick-next" alt="Next Slide"></button>',
		focusOnSelect: true,
		adaptiveHeight: true,
		swipe: false
	});

	// mobile explanation slider
	$slick_slider = $('.mobile-explanations-slider');
	settings_slider = {
	    dots: false,
	    infinite: false,
		speed: 2,
		slidesToShow: 1,
		slidesToScroll: 1,
		swipe: true,
		adaptiveHeight: true,
		touchMove: true,
		focusOnSelect: true,
		mobileFirst: true,
		lazyLoad: 'ondemand',
		prevArrow: '<button class="mobile-button-prev hidden btn btn--ghost-purple" alt="Previous Explanation">Previous Explanation</button>',
		nextArrow: '<button class="mobile-button-next btn btn--ghost-purple" alt="Next Explanation">Next Explanation</button>',
	};
	slick_on_mobile( $slick_slider, settings_slider);

	// slick on mobile
	function slick_on_mobile(slider, settings){
		$(window).on('load resize', function() {
		  if ($(window).width() > 1023) {
		    if (slider.hasClass('slick-initialized')) {
		      slider.slick('unslick');
		    }
		    return;
		  }
		  if (!slider.hasClass('slick-initialized')) {
		    return slider.slick(settings);
		  }
		});
	}

	$slick_slider.on('afterChange', function(event, slick, currentSlide) {  	
		//If we're on the first slide hide the Previous button.
		if(currentSlide === 0) {
			$('.mobile-button-prev').addClass('hidden');
		} else {
		    $('.mobile-button-prev').removeClass('hidden');
		}

		//If we're on the last slide hide the Next button.
		if (slick.slideCount - 1 === currentSlide++) {
			$('.mobile-button-next').addClass('hidden');
		} else {
		    $('.mobile-button-next').removeClass('hidden');
		}
  	});
}

$(function () {
	// update progress bar
	function progressBar(quiz, slideIndex) {
		if (quiz.find('.quiz-progress--bar').length) {
			quizLength = quiz.find('.quiz-progress--track').attr('data-quizLength');
			quizBarWidth = quiz.find('.quiz-progress--track').width();
			if (quiz.find('.quiz-progress--track').attr('data-quizLength') >= slideIndex) {
				quiz.find('.quiz-question--curentIndex').text(slideIndex);
			}
			quiz.find('.quiz-progress--bar').css({ "width": (quizBarWidth / quizLength) * slideIndex + "px" });
		}
	}

	// select an answer and add correct/incorrect/selected classes
	function selectAnswer(selected, correct) {
		selected.parent().find('li').removeClass('answer-selected');
		selected.addClass('answer-selected');
		selected.closest('.quiz-question--options').find('.disabled').removeClass('disabled');
		selected.closest('.quiz-question--options').attr('data-pointValue', selected.attr('data-correct'));
		questionId = selected.closest('.question-container').attr('data-questionID');
		optionId = selected.attr('data-optionID');
		$('.quiz-explanations--ex[data-questionID="' + questionId + '"]').find('li:not([class*="correct-answer"])[data-optionID="' + optionId + '"]').addClass('incorrect-answer');
	}

	// select multiple answer and add correct/incorrect/selected classes
	function selectMCAnswer(selected, correct) {
		selected.toggleClass('answer-selected');

		amountCorrectNum = 0; 
		amountSelected = 0;  
		totalPoints = 0;
		amountCorrect = selected.closest('.quiz-question--mc--options li');
		amountCorrect.each(function() {
			if($(this).attr('data-correct') === "1") {
				amountCorrectNum++;
			}
			if($(this).hasClass('answer-selected')) {
				amountSelected++;
			}
		});
		if(amountSelected === amountCorrectNum) {
			$('.answer-selected').each(function() {
				totalPoints = parseInt($(this).attr('data-correct'));
			});
			if(totalPoints === amountCorrectNum) {
				selected.closest('.quiz-question--mc--options').attr('data-pointValue', selected.attr('data-correct'));
			}
		} else {
			selected.closest('.quiz-question--mc--options').attr('data-pointValue', 0);
		}
		
		questionId = selected.closest('.question-container').attr('data-questionID');
		optionId = selected.attr('data-optionID');
		$('.quiz-explanations--ex[data-questionID="' + questionId + '"]').find('li:not([class*="correct-answer"])[data-optionID="' + optionId + '"]').addClass('incorrect-answer');
	}

	// select a bucketed option selected classes
	function singleSelection(selected) {
		selected.parent().find('.quiz-binary--options-selection').removeClass('answer-selected').addClass('not-selected');
		selected.addClass('answer-selected').removeClass('not-selected');
		selected.closest('.quiz-binary--options').find('.disabled').removeClass('disabled');
	}

	// progress to next slide
	function goToNextSlide(slider, currentSlide) {
		slider.closest('.quiz-slider').slick('slickGoTo', currentSlide++);
		$('html,body').animate({ scrollTop: slider.closest('.quiz-slider').offset().top - 100},0);
	}

	// grade the quiz!
	function gradeQuiz(quiz) {
		correct = 0;
		total = quiz.closest('.quiz').find('.quiz-progress--track').attr('data-quizLength');
		quiz.find('.quiz-question--options, .quiz-question--mc--options').each(function () {
			if ($(this).attr('data-pointValue') && $(this).attr('data-pointValue') == 1) {
				correct++;
			}
		});
		gradingGroup($slider.closest('.quiz-slider'));
	}

	function gradingGroup(quiz) {
		percentage = $('.quiz').parent().find('.quiz-mc').attr('data-score') == "percentage";
		if (percentage) {
			quiz.find('.quiz-results').find('.quiz-results-text').text('You got ' + (Math.round(correct)/total *100) + '%.');
		} else {
			quiz.find('.quiz-results').find('.quiz-results-text').text('You got ' + Number(correct) + ' out of ' + total + ' correct.');
		}

		quiz.find('.quiz-result').each(function (e) {
			$(this).css({ "display": "none" });
			if (correct >= $(this).attr('data-lowRange') && correct <= $(this).attr('data-highRange')) {
				$(this).css({ "display": "block" });
			}
		});

		quiz.closest('.quiz-slider').slick('resize');
	}

	function determineBucket(quiz) {
		pointValue = 0;
		quiz.find('.answer-selected').each(function (e) {
			pointValue = Number(pointValue) + Number($(this).attr('data-pointValue'));
		});
		quiz.find('.quiz-result').each(function (e) {
			$(this).css({ "display": "none" });
			if (pointValue >= $(this).attr('data-lowRange') && pointValue <= $(this).attr('data-highRange')) {
				$(this).css({ "display": "block" });
			}
		});
	}

	// init sliders


	// maybe wrap into quiz init funct
	$('.quiz').each(function () {
		$quiz = $(this);
		progressBar($quiz, 1);
	});
	
	//check if quiz had lead gate slide
	var hasPreForm = false;
	if ( $(".quiz").hasClass("hasPreForm") )  {
		hasPreForm = true;
	}

	//check if quiz had results gate slide
	var hasPostForm = false;
	if ( $(".quiz").hasClass("hasPostForm") )  {
		hasPostform = true;
	}
	// select an answer
	$('.quiz-question--options').find('li').click(function (e) {
		$this = $(this);
		if (!$this.hasClass('disable')) {
			selectAnswer($this, $(this).attr('data-correct'));
		}
		e.preventDefault();
	});

	// select an  MC answer
	$('.quiz-question--mc--options').find('li').click(function (e) {
		$this = $(this);
		if (!$this.hasClass('disabled')) {
			selectMCAnswer($this, $(this).attr('data-correct'));
			
		}
		totalPoints = $this.closest('.quiz-question--mc--options').find('li[data-correct="1"]').length;
		answerSelection = $this.closest('.quiz-question--mc--options').find('li.answer-selected').length;

		if (answerSelection >= totalPoints) {	
			$this.closest('.quiz-question--mc--options').find('.btn.binary-get-results').removeClass('disabled');
		} else {
			$('.btn.binary-get-results').addClass('disabled');
		}
		e.preventDefault();
	});

	// select bucketed option
	$('.quiz-binary--options-selection').click(function (e) {
		$selected = $(this);
		singleSelection($selected);
		e.preventDefault();
	});


	// progress the slider, update progress bar
	$('.quiz-progress').click(function (e) {
		currentSlide = $(this).closest('.quiz-slider').slick('slickCurrentSlide') + 1;
		$slider = $(this);
		$quiz = $(this).closest('.quiz');
		goToNextSlide($slider, currentSlide);
		progressBar($quiz, currentSlide + 1);
		e.preventDefault();
	});

	// get results
	$('.binary-get-results').click(function (e) {
		currentSlide = $(this).closest('.quiz-slider').slick('slickCurrentSlide') + 1;
		$slider = $(this);
		if ($slider.closest('.quiz').hasClass('quiz-binary')) {
			determineBucket($slider.closest('.quiz-slider'));
		} else {
			gradeQuiz($slider.closest('.quiz-slider'));
			// gradeMCQuiz($slider.closest('.quiz-slider'));
		}

		goToNextSlide($slider, currentSlide);
		e.preventDefault();
	});

	//hide progress bar during results
	$('.mc-get-results').click(function(e) {
        $('.progress-bar').hide();
	});

	// see explanations
	$('.see-explanations').click(function (e) {
		$(this).closest('.quiz').find('.quiz-explanations').css({ "height": "auto", "display": "block" });
		$(this).closest('.quiz').find('.quiz-result').css({ "height": "auto", "display": "block" });
		$(window).resize();
		$(this).closest('.slick-list').css({"height": $(this).closest('.slick-slide').height()});
		$(this).closest('.quiz').find('.quiz-slider').slick('resize');
		e.preventDefault();
		$('.quiz-progress').remove();
	});

});


//////////////////
// WEBPACK FOOTER
// ./public/js/quiz.js
// module id = 86
// module chunks = 0